// extracted by mini-css-extract-plugin
module.exports = {"markdownContent":"MarkdownPage-module--markdown-content--TRKOD"};